var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout-navigator"},[_c('div',{staticClass:"checkout-steps"},_vm._l((_vm.steps),function(step){return _c('div',{key:step.name,staticClass:"checkout-navigator__step",class:['tab-' + step.name, { active: step.active, done: step.unlocked }],on:{"click":function($event){return _vm.changeStep(step.name)}}},[_c('span',{class:[
                    {
                        'icon-profile': step.name === 'login',
                        'icon-truck': step.name === 'shipping',
                        'icon-credit-card': step.name === 'invoice',
                        'icon-check': step.name === 'confirm',
                    } ]})])}),0),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }